import React, { FC, Dispatch, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';

import { useMerchantPaymentConfigContext } from 'hooks/context/merchantPaymentConfig';
import { Icon } from 'components/Icon';
import { isICASupported } from 'utils/Ach';
import { PAYMENT_METHODS_TEST_IDS } from './const';

import styles from './styles.module.scss';

export type PaymentMethodOption = {
  key: string;
  icon: string;
  testId: string;
}

export const PAYMENT_METHODS_OPTIONS: PaymentMethodOption[] = [{
  key: 'creditDebitCard',
  icon: 'creditDebitCard',
  testId: PAYMENT_METHODS_TEST_IDS.creditCard,
},{
  key: 'ach',
  icon: 'ach',
  testId: PAYMENT_METHODS_TEST_IDS.ach,
}];

type PaymentMethodsProps = {
  total: number;
  selection: string;
  setSelection: Dispatch<SetStateAction<string>>;
};

const getSupportedPaymentMethods = (achSupported = false) => {
  if (achSupported) return PAYMENT_METHODS_OPTIONS;

  return [PAYMENT_METHODS_OPTIONS[0]];
};

const PaymentMethods: FC<PaymentMethodsProps> = ({ total, selection, setSelection }) => {
  const { t } = useTranslation();
  const { merchantPaymentConfig } = useMerchantPaymentConfigContext();
  const isAchIcaSupported = isICASupported(merchantPaymentConfig);
  const onSelection = (selectedKey: string) => {
    setSelection(selectedKey);
  };

  const supportedPaymentMethods = getSupportedPaymentMethods(isAchIcaSupported);

  if (supportedPaymentMethods.length === 1) return null;

  return (
    <div data-testid={PAYMENT_METHODS_TEST_IDS.paymentMethods} className={styles.paymentMethods}>
      <p>
        {t('paymentMethods.title')}
      </p>
      <div className={styles.accordian}>
        {supportedPaymentMethods.map(
          (val) => {

            return (
              <div className={clsx(styles.option, { [styles.selected]: (selection === val.key) })} key={val.key}>
                <input data-testid={val.testId} onChange={() => onSelection(val.key)} type="radio" id={val.key} name={'paymentMethods'} />
                <label  htmlFor={val.key}>
                  <Icon className={styles.icon} name={val.icon} />
                  <span>{t(`paymentMethods.${val.key}`)}</span>
                </label>
              </div>
            );
          }
        )}
      </div>
    </div>
  );
};

export { PaymentMethods };
